/* src/app/indirect-rate/indirect-rate/indirect-rate.component.scss */
/*# sourceMappingURL=indirect-rate.component.css.map */
